import { useFlag } from "@unleash/proxy-client-react";

/**
 * Unleash release toggle gating the consolidation-prioritization admin surface:
 * the "Konsolideringsprioritering" settings view where admins prioritize laws
 * (or parts of their timeline) for consolidation. The flag (together with the
 * ManageConsolidationPriority permission) is the access control — there is no
 * parent-tenant restriction.
 *
 * Deliberately separate from the reader-facing Consolidation-Rendering flag so
 * the admin surface can roll out (and be killed) independently of the
 * consolidated-law viewer. Flags come from the Unleash proxy only — never
 * GET /api/featureflag (LAR-374).
 *
 * Keep the literal flag name in this file only.
 */
export const CONSOLIDATION_PRIORITIZATION_FEATURE_FLAG =
  "Consolidation-Prioritization";

const useConsolidationPrioritizationEnabled = (): boolean =>
  useFlag(CONSOLIDATION_PRIORITIZATION_FEATURE_FLAG);

export default useConsolidationPrioritizationEnabled;
